/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface TOTPMethodOptions
 */
export interface TOTPMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof TOTPMethodOptions
     */
    method: FactorMethod;
}



/**
 * Check if a given object implements the TOTPMethodOptions interface.
 */
export function instanceOfTOTPMethodOptions(value: object): value is TOTPMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function TOTPMethodOptionsFromJSON(json: any): TOTPMethodOptions {
    return TOTPMethodOptionsFromJSONTyped(json, false);
}

export function TOTPMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function TOTPMethodOptionsToJSON(json: any): TOTPMethodOptions {
    return TOTPMethodOptionsToJSONTyped(json, false);
}

export function TOTPMethodOptionsToJSONTyped(value?: TOTPMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
    };
}

